import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  Box,
  Typography,
} from '@mui/material';

function CreateGroupDialog({ open, onClose, users, currentUserId, onCreateGroup }) {
  const [groupName, setGroupName] = useState('');
  const [selectedUserIds, setSelectedUserIds] = useState([]);

  const availableUsers = users.filter(user => user.id !== currentUserId);

  const handleSubmit = () => {
    if (!groupName.trim()) {
      alert('Please enter a group name');
      return;
    }

    if (selectedUserIds.length === 0) {
      alert('Please select at least one user');
      return;
    }

    onCreateGroup(groupName.trim(), selectedUserIds);
    setGroupName('');
    setSelectedUserIds([]);
    onClose();
  };

  const handleClose = () => {
    setGroupName('');
    setSelectedUserIds([]);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Create New Group</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
          <TextField
            label="Group Name"
            value={groupName}
            onChange={(e) => setGroupName(e.target.value)}
            fullWidth
            required
            placeholder="Enter group name"
          />
          
          <FormControl fullWidth>
            <InputLabel>Select Users</InputLabel>
            <Select
              multiple
              value={selectedUserIds}
              onChange={(e) => setSelectedUserIds(e.target.value)}
              renderValue={(selected) => {
                if (selected.length === 0) {
                  return <Typography color="text.secondary">Select users...</Typography>;
                }
                const selectedUsers = availableUsers.filter(u => selected.includes(u.id));
                return selectedUsers.map(u => u.username).join(', ');
              }}
            >
              {availableUsers.map((user) => (
                <MenuItem key={user.id} value={user.id}>
                  <Checkbox checked={selectedUserIds.includes(user.id)} />
                  <ListItemText primary={user.username} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={handleSubmit} variant="contained" color="primary">
          Create Group
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CreateGroupDialog;

